import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { FieldHistory } from 'SharedDir/declarations/fields';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'FieldHistoryBtn' },
  __name: 'FieldHistoryBtn',
  props: {
    history: {},
    noBadge: { type: Boolean, default: false }
  },
  setup(__props: any) {


const props = __props;
const historyDepth = computed(() => props.history.length);

return (_ctx: any,_cache: any) => {
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createBlock(_component_q_icon, {
    class: "s-shrink cursor-pointer",
    color: "brand-grey",
    flat: "",
    name: "las la-history"
  }, {
    default: _withCtx(() => [
      (1)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!_ctx.noBadge)
              ? (_openBlock(), _createBlock(_component_q_badge, {
                  key: 0,
                  class: "float-right",
                  floating: "",
                  color: "brand-warning",
                  rounded: "",
                  transparent: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(historyDepth.value), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_q_tooltip, {
              anchor: "center left",
              self: "center end"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Доступно " + _toDisplayString(historyDepth.value) + " прошлых версии этого поля ", 1)
              ]),
              _: 1
            })
          ], 64))
        : (historyDepth.value > 0)
          ? (_openBlock(), _createBlock(_component_q_tooltip, {
              key: 1,
              anchor: "center left",
              self: "center end"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Доступна " + _toDisplayString(historyDepth.value) + " прошлая версии этого поля ", 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})